import React from 'react';
import type { ReactNode } from 'react';
import { Alert, AlertAction, AlertDescription } from '@tectonics/components/ui/alert';
import { TbX } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import { useCardSecurityCodeAlert } from './hooks/use-card-security-alert';


function FieldCardSecurityCodeAlert(): ReactNode {
  const { t } = useTranslation('opened-page', { keyPrefix: 'volcanes.form.cardSecurityCode' });
  const { visible, dismiss } = useCardSecurityCodeAlert();

  if (!visible) return null;

  return (
    <Alert lookAndFeel="volcanes" className="border-l-4 border-volcanes-error-default">
      <AlertDescription>
        <strong>{t('errorBannerTitle')}</strong>{' '}
        {t('errorBannerDescription')}
      </AlertDescription>
      <AlertAction>
        <button
          type="button"
          aria-label={t('errorBannerClose')}
          onClick={dismiss}
          className="bg-transparent border-0 cursor-pointer"
        >
          <TbX className="size-4" />
        </button>
      </AlertAction>
    </Alert>
  );
}

export { FieldCardSecurityCodeAlert };
